import { I18n } from 'common/i18n';
import * as constants from 'common/components/AssetBrowser/lib/constants';
import { SelectDropdownConfig } from './filter-config';
import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { FilterScope, getAllOption, getScope } from './translations';
import { FilterType, SelectOption } from './types';

const scope = getScope(FilterScope.Version);

const getVersionOptions = (list: string[]): SelectOption[] => {
  const versionOptions = [getAllOption(scope)];

  list?.forEach((version) => {
    if (version === 'published') {
      versionOptions.push({
        label: I18n.t('options.published', { scope }),
        value: constants.VERSION_PUBLISHED,
      });
    } else if (version === 'draft') {
      versionOptions.push({
        label: I18n.t('options.draft', { scope }),
        value: constants.VERSION_DRAFT,
      });
    }
  });

  return versionOptions;
};

export const versionConfigs: SelectDropdownConfig = {
  filterName: Filters.Version,
  label: I18n.t('label', { scope: getScope(FilterScope.Version) }),
  getOptions: (list: string[]) => getVersionOptions(list),
  dispatchAction: filters.changeVersion,
  filterType: FilterType.SelectDropdown,
};
